import { ComponentProps, useCallback } from 'react';
import { TurnaroundSelectEntities } from './TurnaroundSelectEntities';
import { useTurnaroundOriginSelectedEntities } from '../hooks/useTurnaroundOriginSelectedEntities';
import { useTurnaroundOriginEntities } from '../hooks/useTurnaroundOriginEntities';

type Props = ComponentProps<'div'>;

export const TurnaroundSelectEntitiesOrigin = ({ ...props }: Props) => {
  const [turnaroundOriginSelectedEntities, setTurnaroundOriginSelectedEntities] = useTurnaroundOriginSelectedEntities();

  const {
    deliveryStatus,
    sets: originSets,
    implants: originImplants,
    isLoading: isLoadingOriginEntities,
  } = useTurnaroundOriginEntities();

  const onSelectSet = useCallback(
    (setKitInstanceId: string) => {
      // If it's already selected, remove it
      if (
        turnaroundOriginSelectedEntities.some(
          entity => entity.type === 'set' && entity.setKitInstanceId === setKitInstanceId,
        )
      ) {
        setTurnaroundOriginSelectedEntities(prev =>
          prev.filter(entity => entity.type !== 'set' || entity.setKitInstanceId !== setKitInstanceId),
        );
      } else {
        setTurnaroundOriginSelectedEntities(prev => [...prev, { type: 'set', setKitInstanceId }]);
      }
    },
    [turnaroundOriginSelectedEntities, setTurnaroundOriginSelectedEntities],
  );

  const onSelectImplants = useCallback(() => {
    // If the implants are already selected, remove them, otherwise add them
    if (turnaroundOriginSelectedEntities.some(entity => entity.type === 'implant')) {
      setTurnaroundOriginSelectedEntities(prev => prev.filter(entity => entity.type !== 'implant'));
    } else {
      const implantsToAdd = originImplants.map(implant => ({
        type: 'implant' as const,
        implantInstanceId: implant.implantInstanceId,
      }));

      setTurnaroundOriginSelectedEntities(prev => [...prev, ...implantsToAdd]);
    }
  }, [turnaroundOriginSelectedEntities, originImplants, setTurnaroundOriginSelectedEntities]);

  return (
    <TurnaroundSelectEntities
      {...props}
      deliveryStatus={deliveryStatus}
      variant="origin"
      sets={originSets}
      implants={originImplants}
      selectedEntities={turnaroundOriginSelectedEntities}
      isLoading={isLoadingOriginEntities}
      onSelectSet={onSelectSet}
      onSelectImplants={onSelectImplants}
    />
  );
};
